const SvgIconLightmode = (props) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 17c-1.383 0-2.563-.488-3.537-1.463C7.488 14.563 7 13.383 7 12s.487-2.563 1.463-3.537C9.438 7.488 10.617 7 12 7s2.563.487 3.537 1.463C16.512 9.438 17 10.617 17 12s-.488 2.563-1.463 3.537C14.563 16.512 13.383 17 12 17ZM1 12.75v-1.5h4v1.5H1Zm18 0v-1.5h4v1.5h-4ZM11.25 5V1h1.5v4h-1.5Zm0 18v-4h1.5v4h-1.5ZM6.525 7.575 4.05 5.1 5.1 4.05l2.475 2.475-1.05 1.05ZM18.9 19.95l-2.475-2.475 1.05-1.05L19.95 18.9l-1.05 1.05ZM17.475 7.575l-1.05-1.05L18.9 4.05l1.05 1.05-2.475 2.475ZM5.1 19.95 4.05 18.9l2.475-2.475 1.05 1.05L5.1 19.95Z" />
  </svg>
);

export default SvgIconLightmode;
